import React, { useState } from 'react'
import CustomMultiSelectCheckbox from './CustomMultiSelectCheckbox'
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import styled from "@emotion/styled";
import InfoIcon from '@mui/icons-material/Info';

const loanType = [];
const installmentFrequencyOptions = [];

const CustomTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        fontSize: '2rem',
    },
}));


export default function EditEvUtility({ handlePage }) {
    const [errors, setErrors] = useState({});
    const [expanded, setExpanded] = React.useState(false);
    const [data, setData] = React.useState({
        schemeName: "",
        schemeCode: "",
        startDate: "",
        endDate: "",
        installmentFrequency: "",
        interestType: "",
        tenureMore: "",
        advanceEmi: "",
    });

    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };

    const handleCategoryValueChange = (e) => {

    }


    return (
        <>
            <div className="EditEvUtility">
                <div className="container-fluid expense-config">
                    <div style={{ margin: '30px 0 20px 0' }}>
                        <button className='searchbtn btn btn-primary' onClick={() => handlePage('list')} style={{ marginRight: '15px', padding: '8px 10px' }}><i class="fa fa-arrow-left" aria-hidden="true"></i> Back to List</button>

                    </div>

                    <div className="target-box">
                        <h3>Add/Update Schemes</h3>
                        <hr style={{ borderTop: "1px solid rgb(0, 0, 0)" }} />
                        <div style={{ padding: '10px', background: " rgb(255, 255, 255)" }}>
                            <div className="EvFormSection">
                                <div className="inputGrp" style={{ textAlign: 'center' }}>
                                    <CustomMultiSelectCheckbox labelValue={"Loan Type"} names={loanType} customStyles={{ width: '50%', background: "rgb(244, 243, 241)" }} />
                                </div>

                            </div>

                            <div className="EvFormSection">
                                <Accordion expanded={expanded === 'panel1'} onChange={handleChange('panel1')} style={{ background: '#f4f3f1' }}>
                                    <AccordionSummary
                                    style={{borderBottom:'1px solid #c4c3c3'}}
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel1bh-content"
                                        id="panel1bh-header"
                                    >
                                        <Typography sx={{ width: '33%', flexShrink: 0, fontSize: '18px' }} >
                                            Scheme Details
                                        </Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <Typography>
                                            <div className="row">
                                                <div className="col-sm-6 col-xs-12">
                                                    <div style={{ display: 'flex', marginTop: '20px' }}>
                                                        <div style={{ width: '40%' }}>
                                                            <label style={{ marginTop: '10px', fontSize: "14px" }}>Scheme Name  <span style={{ color: 'red' }}>*</span></label>
                                                        </div>
                                                        <div style={{ width: '40%' }}>
                                                            <input
                                                                style={{ background: '#fff', border: '1px solid' }}
                                                                className="form-control"
                                                                type="text"
                                                                name="schemeName"
                                                                value={data.schemeName}
                                                                onChange={handleCategoryValueChange}
                                                                placeholder='Enter Scheme Name'
                                                            />
                                                            {errors.schemeName && (
                                                                <span style={{ color: 'red', fontSize: '10px', marginTop: '5px' }}>{errors.schemeName}</span>
                                                            )}
                                                        </div>
                                                        <div style={{ width: '20%' }}>
                                                            <CustomTooltip title={"this denotes the Scheme Name given by User"} >
                                                                <InfoIcon style={{ margin: '8%', cursor: 'pointer',fontSize:'20px' }} />
                                                            </CustomTooltip>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-sm-6 col-xs-12">
                                                    <div style={{ display: 'flex', marginTop: '20px' }}>
                                                        <div style={{ width: '40%' }}>
                                                            <label style={{ marginTop: '10px', fontSize: "14px" }}>Scheme Code <span style={{ color: 'red' }}>*</span></label>
                                                        </div>
                                                        <div style={{ width: '40%' }}>
                                                            <input
                                                                style={{ background: '#fff', border: '1px solid' }}
                                                                className="form-control"
                                                                type="text"
                                                                name="schemeCode"
                                                                value={data.schemeCode}
                                                                onChange={handleCategoryValueChange}
                                                                placeholder='Enter Scheme Code'
                                                            />
                                                            {errors.schemeName && (
                                                                <span style={{ color: 'red', fontSize: '10px', marginTop: '5px' }}>{errors.schemeName}</span>
                                                            )}
                                                        </div>
                                                        <div style={{ width: '20%' }}>
                                                            <CustomTooltip title={" This is the code for the scheme given by the user. This will be used in API as we will pass ID while pushing the request."} >
                                                                <InfoIcon style={{ margin: '8%', cursor: 'pointer',fontSize:'20px' }} />
                                                            </CustomTooltip>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                            <div className="row">
                                                <div className="col-sm-6 col-xs-12">
                                                    <div style={{ display: 'flex', marginTop: '20px' }}>
                                                        <div style={{ width: '40%' }}>
                                                            <label style={{ marginTop: '10px', fontSize: "14px" }}>Start Date  <span style={{ color: 'red' }}>*</span></label>
                                                        </div>
                                                        <div style={{ width: '40%' }}>
                                                            <input
                                                                style={{ background: '#fff', border: '1px solid' }}
                                                                className="form-control"
                                                                type="date"
                                                                name="startDate"
                                                                value={data.startDate}
                                                                onChange={handleCategoryValueChange}
                                                            />
                                                            {errors.startDate && (
                                                                <span style={{ color: 'red', fontSize: '10px', marginTop: '5px' }}>{errors.startDate}</span>
                                                            )}
                                                        </div>
                                                        <div style={{ width: '20%' }}>
                                                            <CustomTooltip title={" This represents the start date of scheme. From this date scheme will be shown while creating a lead or Loan."} >
                                                                <InfoIcon style={{ margin: '8%', cursor: 'pointer',fontSize:'20px' }} />
                                                            </CustomTooltip>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-sm-6 col-xs-12">
                                                    <div style={{ display: 'flex', marginTop: '20px' }}>
                                                        <div style={{ width: '40%' }}>
                                                            <label style={{ marginTop: '10px', fontSize: "14px" }}>End Date <span style={{ color: 'red' }}>*</span></label>
                                                        </div>
                                                        <div style={{ width: '40%' }}>
                                                            <input
                                                                style={{ background: '#fff', border: '1px solid' }}
                                                                className="form-control"
                                                                type="date"
                                                                name="endDate"
                                                                value={data.endDate}
                                                                onChange={handleCategoryValueChange}
                                                            />
                                                            {errors.endDate && (
                                                                <span style={{ color: 'red', fontSize: '10px', marginTop: '5px' }}>{errors.endDate}</span>
                                                            )}
                                                        </div>
                                                        <div style={{ width: '20%' }}>
                                                            <CustomTooltip title={"This represents End date of the scheme. I.e., once the scheme is expired then the scheme won’t be shown at the time of creating a Lead or Loan. "} >
                                                                <InfoIcon style={{ margin: '8%', cursor: 'pointer',fontSize:'20px' }} />
                                                            </CustomTooltip>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>

                                        </Typography>
                                    </AccordionDetails>
                                </Accordion>

                                <Accordion expanded={expanded === 'panel2'} onChange={handleChange('panel2')} style={{ background: '#f4f3f1' ,marginTop:'15px'}}>
                                    <AccordionSummary
                                    style={{borderBottom:'1px solid #c4c3c3'}}
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel2bh-content"
                                        id="panel2bh-header"
                                    >
                                        <Typography sx={{ width: '33%', flexShrink: 0, fontSize: '18px' }} >
                                        Amortization Settings
                                        </Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <Typography>
                                            <div className="row">
                                                <div className="col-sm-6 col-xs-12">
                                                    <div style={{ display: 'flex', marginTop: '20px' }}>
                                                        <div style={{ width: '40%' }}>
                                                            <label style={{ marginTop: '10px', fontSize: "14px" }}>Installment Frequency  <span style={{ color: 'red' }}>*</span></label>
                                                        </div>
                                                        <div style={{ width: '40%' }}>
                                                           
                                                            <select
                                                             style={{ background: '#fff', border: '1px solid' }}
                                                                className="form-control" name-="installmentFrequency"
                                                             value={data.installmentFrequency}
                                                             onChange={handleCategoryValueChange}
                                                             >
                                                                <option>Select</option>
                                                                {
                                                                    installmentFrequencyOptions && installmentFrequencyOptions?.length > 0 ? installmentFrequencyOptions?.map((value,index)=>{
                                                                        return(
                                                                            <option key={index} value={value}>{value}</option>
                                                                        )
                                                                    })
                                                                :''}
                                                            </select>
                                                            {errors.installmentFrequency && (
                                                                <span style={{ color: 'red', fontSize: '10px', marginTop: '5px' }}>{errors.installmentFrequency}</span>
                                                            )}
                                                        </div>
                                                        <div style={{ width: '20%' }}>
                                                            <CustomTooltip title={"This is used to select the frequency type for the loan how the amortization sheet to be created such as Weekly, Monthly, Quarterly, Half-yearly and Yearly etc."} >
                                                                <InfoIcon style={{ margin: '8%', cursor: 'pointer',fontSize:'20px' }} />
                                                            </CustomTooltip>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-sm-6 col-xs-12">
                                                    <div style={{ display: 'flex', marginTop: '20px' }}>
                                                        <div style={{ width: '40%' }}>
                                                            <label style={{ marginTop: '10px', fontSize: "14px" }}>Interest Type
                                                            <span style={{ color: 'red' }}>*</span></label>
                                                        </div>
                                                        <div style={{ width: '40%' }}>
                                                           
                                                             <select
                                                             style={{ background: '#fff', border: '1px solid' }}
                                                                className="form-control"
                                                                name="interestType"
                                                             value={data.interestType}
                                                             onChange={handleCategoryValueChange}
                                                             >
                                                                <option>Select</option>
                                                                <option value={"flat"}>Flat</option>
                                                                <option value={"diminishing"}>Diminishing</option>
                                                               
                                                            </select>
                                                            {errors.interestType && (
                                                                <span style={{ color: 'red', fontSize: '10px', marginTop: '5px' }}>{errors.interestType}</span>
                                                            )}
                                                        </div>
                                                        <div style={{ width: '20%' }}>
                                                            <CustomTooltip title={" This is used to select the interest type such as Flat or Diminishing. Based on type the schedule will generate."} >
                                                                <InfoIcon style={{ margin: '8%', cursor: 'pointer',fontSize:'20px' }} />
                                                            </CustomTooltip>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                            <div className="row">
                                                <div className="col-sm-6 col-xs-12">
                                                    <div style={{ display: 'flex', marginTop: '20px' }}>
                                                        <div style={{ width: '40%' }}>
                                                            <label style={{ marginTop: '10px', fontSize: "14px" }}>No of Tenure more  <span style={{ color: 'red' }}>*</span></label>
                                                        </div>
                                                        <div style={{ width: '40%' }}>
                                                            <input
                                                                style={{ background: '#fff', border: '1px solid' }}
                                                                className="form-control"
                                                                type="number"
                                                                name="tenureMore"
                                                                value={data.tenureMore}
                                                                onChange={handleCategoryValueChange}
                                                            />
                                                            {errors.tenureMore && (
                                                                <span style={{ color: 'red', fontSize: '10px', marginTop: '5px' }}>{errors.tenureMore}</span>
                                                            )}
                                                        </div>
                                                        <div style={{ width: '20%' }}>
                                                            <CustomTooltip title={"This field will work only when indicative ROI is enabled. The functionality of this is suppose if the user given no. of tenure is 1 and total Emi is 15 then the schedule will calculate for 16 but the rate of interest will calculate for 15 EMI's."} >
                                                                <InfoIcon style={{ margin: '8%', cursor: 'pointer',fontSize:'20px' }} />
                                                            </CustomTooltip>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-sm-6 col-xs-12">
                                                    <div style={{ display: 'flex', marginTop: '20px' }}>
                                                        <div style={{ width: '40%' }}>
                                                            <label style={{ marginTop: '10px', fontSize: "14px" }}>Advance EMI <span style={{ color: 'red' }}>*</span></label>
                                                        </div>
                                                        <div style={{ width: '40%' }}>
                                                            <input
                                                                style={{ background: '#fff', border: '1px solid' }}
                                                                className="form-control"
                                                                type="number"
                                                                name="advanceEmi"
                                                                value={data.advanceEmi}
                                                                onChange={handleCategoryValueChange}
                                                            />
                                                            {errors.advanceEmi && (
                                                                <span style={{ color: 'red', fontSize: '10px', marginTop: '5px' }}>{errors.advanceEmi}</span>
                                                            )}
                                                        </div>
                                                        <div style={{ width: '20%' }}>
                                                            <CustomTooltip title={"If the user gives 0 in scheme, then this field will be open during loan creation or CAM Submission.If user gives any value other than zero I.e., 1, 2 etc. then this field will be freezed with that value."} >
                                                                <InfoIcon style={{ margin: '8%', cursor: 'pointer',fontSize:'20px' }} />
                                                            </CustomTooltip>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>

                                        </Typography>
                                    </AccordionDetails>
                                </Accordion>
                               
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        </>
    )
}
